<template>
  <div v-html="date"></div>
</template>

<script>
import Statuses from '@/services/statuses'

export default {
  name: 'BuyoutDate',
  created: function () {
    if (!this.dates) {
      return
    }
    const f = this.$root.$options.filters['localizedDateShort']
    switch (this.status){
      case this.statuses.progress.id:
        if (this.dates.stop) {
          this.date = `дата стопа: <b style="color:${this.statuses.progress.color}">${f(this.dates.stop)}</b>`
        }
        break
      case this.statuses.purchasing.id:
      case this.statuses.receptPrepayments.id:
      case this.statuses.receptPayments.id:
        if (this.dates.purchasing) {
          this.date = `оплатить до <b style="color:${this.statuses.purchasing.color}">${f(this.dates.purchasing)}</b>`
        }
        break
      case this.statuses.awaiting.id:
      case this.statuses.delivery.id:
      case this.statuses.transit.id:
      case this.statuses.receivedByOrg.id:
        if (this.dates.delivery) {
          this.date = `ожидаемая дата доставки: <b style="color:${this.statuses.delivery.color}">${f(this.dates.delivery)}</b>`
        }
        break
      case this.statuses.distribution.id:
        if (this.dates.distribution) {
          this.date = `забрать до <b style="color:${this.statuses.distribution.color}">${f(this.dates.distribution)}</b>`
        }
        break
    }
  },
  data () {
    return {
      date: '',
      statuses: Statuses.getStatuses()
    }
  },
  props: {
    dates: {
      type: Object
    },
    status: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped>

</style>